import * as swcHelpers from '@swc/helpers';

const toServerOptIns = (optIns)=>{
    if (!optIns) {
        return {
            optinValues: {}
        };
    }
    var _value;
    return optIns.reduce((result, optIn)=>({
            optinValues: swcHelpers.objectSpread({}, result.optinValues, {
                [optIn.id]: (_value = optIn.value) !== null && _value !== void 0 ? _value : false
            })
        })
    , {
        optinValues: {}
    });
};

export { toServerOptIns };
//# sourceMappingURL=opt-ins-server.js.map
